import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dynatrace = defineConnector({
  identifier: "dynatrace",
  name: "Dynatrace",
  tagLine: "Application performance monitoring",
  keywords: "apm observability oneagent davis entities metrics problems traces",
  logo,
  protocol: "http",
  tags: ["it", "observability"],
  defaultUrlPattern: () => "https://[^/]*\\.live\\.dynatrace\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiToken,
        scheme: "Api-Token",
      },
    ]),
  steps: [
    {
      title: "Generate an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In your Dynatrace environment, go to **Settings > Integration > Dynatrace API** and select **Generate token**. Grant `Read entities` (`entities.read`) for the connection test, plus any other scopes your workflows need.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Domain",
          required: true,
          placeholder: "abc12345.live.dynatrace.com",
          helperText: "Your Dynatrace environment hostname.",
          target: { kind: "configuration", field: "domain" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          placeholder: "dt0c01.XXXX.XXXX",
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v2/entityTypes?pageSize=1`,
  },
  publicEnvVars: ({ domain }) => ({
    DYNATRACE_URL: domain ? `https://${domain}` : "",
  }),
});
